export enum SubscriptionPhase {
  Active = 'active',
  Trial = 'trial',
  Psm = 'psm',
}

export enum SubscriptionStatus {
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  Trialing = 'trialing',
  Active = 'active',
  PastDue = 'past_due',
  Canceled = 'canceled',
  Unpaid = 'unpaid',
  Paused = 'paused',
}

export const MEMBERSHIP_TYPE_LABELS: Record<SubscriptionPhase, string> = {
  [SubscriptionPhase.Trial]: 'CPP',
  [SubscriptionPhase.Psm]: 'Pre-Sold',
  [SubscriptionPhase.Active]: 'Active',
};

export const MEMBERSHIP_STATUS_LABELS: Record<SubscriptionStatus, string> = {
  [SubscriptionStatus.Active]: 'Active',
  [SubscriptionStatus.Trialing]: 'Trialing',
  [SubscriptionStatus.PastDue]: 'Past Due',
  [SubscriptionStatus.Unpaid]: 'Unpaid',
  [SubscriptionStatus.Paused]: 'Paused',
  [SubscriptionStatus.Incomplete]: 'Incomplete',
  [SubscriptionStatus.IncompleteExpired]: 'Incomplete Expired',
  [SubscriptionStatus.Canceled]: 'Canceled',
};
